module.exports = __webpack_public_path__ + "img/canal-futura-site.jpg";